import { getCore } from '../../../client/core/getCore';
import { getDefaultClient } from '../../../client/defaultClient';
import { createApiClient } from '../../apiClient';
import { consumeCaptchaToken } from '../../captcha/consumeCaptchaToken';
import type { OTPVerification } from '../otp.types';

export type SendEmailOTPParams = {
  email: string;
};

/**
 * Sends a one-time password (OTP) to the specified email address.
 *
 * Once you have the OTP code, you should then use `verifyOTP` to verify it and complete the authentication process.
 *
 * @param params.email - The email address to send the OTP to.
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns A promise that resolves to an OTPVerification object containing the email and verification UUID.
 */
export const sendEmailOTP = async (
  { email }: SendEmailOTPParams,
  client = getDefaultClient()
): Promise<OTPVerification> => {
  const core = getCore(client);
  const apiClient = createApiClient({}, client);

  const { verificationUUID } = await apiClient.createEmailVerification({
    emailVerificationCreateRequest: {
      captchaToken: consumeCaptchaToken(client),
      email,
    },
    environmentId: core.environmentId,
  });

  return { email, verificationUUID };
};
